<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1KPxlD/cover.jpeg?1684255541330" alt="This image is the cover for the book Super Demonic Book, Volume 1"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Super Demonic Book, Volume 1
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>Obtaining a book that could change him, a fatty began a new chapter in his life. </strong></p><p>All sorts of vampires, werewolves, Abyss Lords, ancient Evil Gods, and even the living female corpses of the Three Kingdoms' era would appear. What awaited the end was a showdown at the end of the century.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lao ShiRen, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?21727c18